var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1951_92",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34884 8.65116V15H8.65116V8.65116H15V7.34884L8.65116 7.34884V1H7.34884V7.34884L1 7.34884V8.65116H7.34884Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34884 8.65116V15H8.65116V8.65116H15V7.34884L8.65116 7.34884V1H7.34884V7.34884L1 7.34884V8.65116H7.34884Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34884 15H6.74884V15.6H7.34884V15ZM7.34884 8.65116H7.94884V8.05116H7.34884V8.65116ZM8.65116 15V15.6H9.25116V15H8.65116ZM8.65116 8.65116V8.05116H8.05116V8.65116H8.65116ZM15 8.65116V9.25116H15.6V8.65116H15ZM15 7.34884H15.6V6.74884H15V7.34884ZM8.65116 7.34884H8.05116V7.94884H8.65116V7.34884ZM8.65116 1H9.25116V0.4H8.65116V1ZM7.34884 1V0.4H6.74884V1H7.34884ZM7.34884 7.34884V7.94884H7.94884V7.34884H7.34884ZM1 7.34884L1 6.74884H0.4V7.34884H1ZM1 8.65116H0.4V9.25116H1V8.65116ZM7.94884 15V8.65116H6.74884V15H7.94884ZM8.65116 14.4H7.34884V15.6H8.65116V14.4ZM8.05116 8.65116V15H9.25116V8.65116H8.05116ZM15 8.05116H8.65116V9.25116H15V8.05116ZM14.4 7.34884V8.65116H15.6V7.34884H14.4ZM8.65116 7.94884L15 7.94884V6.74884L8.65116 6.74884V7.94884ZM8.05116 1V7.34884H9.25116V1H8.05116ZM7.34884 1.6H8.65116V0.4H7.34884V1.6ZM7.94884 7.34884V1H6.74884V7.34884H7.94884ZM1 7.94884L7.34884 7.94884V6.74884L1 6.74884L1 7.94884ZM1.6 8.65116V7.34884H0.4V8.65116H1.6ZM7.34884 8.05116H1V9.25116H7.34884V8.05116Z",
    fill: "white",
    mask: "url(#path-1-outside-1_1951_92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonChecker);
export default __webpack_public_path__ + "static/media/button-checker.0f2c32af66393d9a3b12d573eac3cd0d.svg";
export { ForwardRef as ReactComponent };